import { Modal as ModalModule, UI, Utils } from 'common';
import isArray from 'lodash/isArray';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import ReactToPrint from 'react-to-print';

const { Modal, ModalButtonActionType } = ModalModule;
const { Session } = Utils;
const { WrappedButton } = UI;

const MailInRefundRequestModal = ({ modalId, data = {} }) => {
	const mailInRefundForms = isArray(data['mail-in_refund_forms'])
		? data['mail-in_refund_forms'][0]?.forms
		: [];
	const { IsInWinClient } = Session.getSettings();
	const componentRef = useRef();

	return (
		<Modal
			modalId={modalId}
			className="history-refund mailin-refund-request-modal"
			header="Refund"
			primaryButton={{
				type: ModalButtonActionType.Ok,
				text: 'Done',
			}}
			secondaryButton={{
				type: ModalButtonActionType.Cancel,
				text: 'Cancel',
			}}
		>
			<b>Mail-in Refund Request</b>
			<p>To complete the request, mail in the following items to Stamps.com</p>
			<strong className="subheader">STEP 1</strong>

			<ReactToPrint
				trigger={() => (
					<WrappedButton
						label="Print Refund Request Form"
						dataqa="mail-in-refund-request-print"
					/>
				)}
				content={() => componentRef.current}
			/>

			<div style={{ display: 'none' }}>
				<div className="mail-in-refund-container" ref={componentRef}>
					{mailInRefundForms.map((mailInRefundForm, i) => (
						<img
							key={i}
							alt="mail-in-refund"
							className="mailin-form"
							src={mailInRefundForm.href}
						/>
					))}
				</div>
			</div>
			<p>
				<strong>STEP 2</strong>
			</p>
			<div className="inner-content">
				<strong>Enclose the following</strong>
			</div>
			<div className="p-grid inner-content">
				<div className="p-col">
					<span className="mailin-icon signed-refund-request" />
					<p className="mailin-text">Signed Refund Request Form</p>
				</div>
				<div className="p-col">
					<span className="mailin-icon postage-details" />
					<p className="mailin-text">Postage Details</p>
				</div>
				<div className="p-col">
					<span className="mailin-icon postage-label" />
					<p className="mailin-text">Postage Labels</p>
				</div>
				<div className="p-col">
					<span className="mailin-icon misprinted-postage" />
					<p className="mailin-text">
						Misprinted Postage (if postage did not print on label sheet)
					</p>
				</div>
			</div>
			<strong>STEP 3</strong>
			<div className="inner-content">
				<p>Mail the envelope within 60 days of the postage print date to:</p>
				<p>
					Attn: Misprint Refunds
					<br />
					4301 Bull Creek Rd Ste 300
					<br />
					Austin, TX 78731-5937
				</p>
				<p>
					Your refund request will be submitted to the U.S. Postal Service® for
					approval once we receive the items above.
				</p>
				<p>
					<span className="link">View Mail-In Refund Request Tutorial</span>
				</p>
				<iframe
					width="560"
					height="355"
					src={
						IsInWinClient
							? '//www.youtube.com/embed/SyAx6IoGO2U'
							: '//www.youtube.com/embed/k105ahOYdhs?wmode=opaque'
					}
					allowFullScreen
					title="video"
				/>
			</div>
		</Modal>
	);
};

MailInRefundRequestModal.propTypes = {
	data: PropTypes.shape({
		refundForms: PropTypes.array,
	}),
};

export default MailInRefundRequestModal;
